import { MouseEvent, ReactElement, cloneElement } from 'react';

import segment, { SegmentDataType, SegmentTypes } from '@flipster/utils/segment';

interface ClickableProps {
  onClick?: (event: MouseEvent) => void;
  // oxlint-disable-next-line no-explicit-any
  [key: string]: any;
}

interface SegmentClickProps<E extends SegmentTypes> {
  children: ReactElement<ClickableProps>;
  event: E;
  data?: SegmentDataType[E];
}

const SegmentClick = <E extends SegmentTypes>({ children, event, data }: SegmentClickProps<E>) => {
  const handleClick = (e: MouseEvent) => {
    segment.track(event, data);

    if (children.props.onClick) {
      children.props.onClick(e);
    }
  };

  return cloneElement(children, {
    ...children.props,
    onClick: handleClick,
  });
};

export default SegmentClick;
